/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * ExportButtonStyled component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */

import styled from 'styled-components';

export const TooltipDivStyled = styled.div`
    display: flex;
    flex-direction: column;
`
